import { render, staticRenderFns } from "./investData.vue?vue&type=template&id=15cc7c10&scoped=true"
import script from "./investData.vue?vue&type=script&lang=js"
export * from "./investData.vue?vue&type=script&lang=js"
import style0 from "./investData.vue?vue&type=style&index=0&id=15cc7c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cc7c10",
  null
  
)

export default component.exports